import Dashboard from "../Pages/Dashboard/Dashboard";
import AllVacancies from "../Pages/Vacancies/AllVacancies";
import CreateVacancy from "../Pages/Vacancies/CreateVacancy";
import PendingApprovals from "../Pages/Vacancies/PendingApprovals";
import ApprovedVacancies from "../Pages/Vacancies/ApprovedVacancies";
import AllJobPosts from "../Pages/JobPosts/AllJobPosts";
import AllCandidates from "../Pages/Candidates/AllCandidates";
import Applications from "../Pages/JobApply/Applications";
import CandidateRequirement from "../Pages/CandidateRequirement/CandidateRequirement";
import InterviewsPage from "../Pages/Interviews/InterviewsPage";
import AllHiringFlows from "../Pages/HiringFlow/AllHiringFlows";
import AllJobDrives from "../Pages/JobDrives/AllJobDrives";
import Connections from "../Pages/Consultancy/Connections";
import ShareRequirement from "../Pages/Consultancy/ShareRequirement";

import { RECRUITMENT, CONSULTANCY } from "./moduleAccess";

export const protectedRoutes = [
  {
    path: "/dashboard",
    component: Dashboard,
    moduleCodes: [RECRUITMENT.DASHBOARD],
  },

  { path: "/recruitment/vacancies", redirectTo: "/recruitment/vacancies/all" },
  {
    path: "/recruitment/vacancies/all",
    component: AllVacancies,
    moduleCodes: [RECRUITMENT.VACANCIES_ALL],
  },
  {
    path: "/recruitment/vacancies/create",
    component: CreateVacancy,
    moduleCodes: [RECRUITMENT.VACANCIES_CREATE],
  },
  {
    path: "/recruitment/vacancies/approvals",
    component: PendingApprovals,
    moduleCodes: [RECRUITMENT.VACANCIES_PENDING_APPROVALS],
  },
  {
    path: "/recruitment/vacancies/approved",
    component: ApprovedVacancies,
    moduleCodes: [RECRUITMENT.VACANCIES_APPROVED],
  },

  { path: "/recruitment/job-posts", redirectTo: "/recruitment/job-posts/all" },
  {
    path: "/recruitment/job-posts/all",
    component: AllJobPosts,
    moduleCodes: [RECRUITMENT.JOB_POSTS_ALL],
  },

  {
    path: "/recruitment/candidates",
    redirectTo: "/recruitment/candidates/all",
  },
  {
    path: "/recruitment/candidates/all",
    component: AllCandidates,
    moduleCodes: [RECRUITMENT.CANDIDATES_ALL],
  },
  {
    path: "/recruitment/candidates/applied",
    component: Applications,
    moduleCodes: [RECRUITMENT.CANDIDATES_APPLIED],
  },
  {
    path: "/recruitment/candidate-requirement",
    component: CandidateRequirement,
    moduleCodes: [CONSULTANCY.CANDIDATE_REQUIREMENT],
  },

  {
    path: "/recruitment/interviews",
    redirectTo: "/recruitment/interviews/pipeline",
  },
  {
    path: "/recruitment/interviews/pipeline",
    component: InterviewsPage,
    moduleCodes: [RECRUITMENT.INTERVIEWS_PIPELINE],
  },
  {
    path: "/recruitment/interviews/schedule",
    component: InterviewsPage,
    moduleCodes: [RECRUITMENT.INTERVIEWS_SCHEDULE],
  },
  {
    path: "/recruitment/interviews/update-status",
    redirectTo: "/recruitment/interviews/schedule",
  },

  {
    path: "/recruitment/hiring-flow",
    redirectTo: "/recruitment/hiring-flow/all",
  },
  {
    path: "/recruitment/hiring-flow/all",
    component: AllHiringFlows,
    moduleCodes: [RECRUITMENT.HIRING_FLOW_ALL],
  },

  {
    path: "/recruitment/job-drives",
    redirectTo: "/recruitment/job-drives/all",
  },
  {
    path: "/recruitment/job-drives/all",
    component: AllJobDrives,
    moduleCodes: [RECRUITMENT.JOB_DRIVES_ALL],
  },

  {
    path: "/recruitment/connections",
    redirectTo: "/recruitment/connections/candidates",
  },
  {
    path: "/recruitment/connections/candidates",
    component: Connections,
    moduleCodes: [RECRUITMENT.CONNECTIONS],
  },
  {
    path: "/recruitment/connections/share",
    component: ShareRequirement,
    moduleCodes: [RECRUITMENT.CONNECTIONS_SHARE_REQUIREMENT],
  },

  { path: "/consultant/job-posts", redirectTo: "/consultant/job-posts/all" },
  {
    path: "/consultant/job-posts/all",
    component: AllJobPosts,
    moduleCodes: [CONSULTANCY.JOB_POSTS_ALL],
  },

  { path: "/consultant/candidates", redirectTo: "/consultant/candidates/all" },
  {
    path: "/consultant/candidates/all",
    component: AllCandidates,
    moduleCodes: [CONSULTANCY.CANDIDATES_ALL],
  },

  { path: "/consultant/job-drives", redirectTo: "/consultant/job-drives/all" },
  {
    path: "/consultant/job-drives/all",
    component: AllJobDrives,
    moduleCodes: [CONSULTANCY.JOB_DRIVES_ALL],
  },

  {
    path: "/consultant/connections",
    component: Connections,
    moduleCodes: [CONSULTANCY.CONNECTIONS],
  },
  {
    path: "/consultant/share-candidates",
    component: ShareRequirement,
    moduleCodes: [CONSULTANCY.SHARE_CANDIDATES],
  },
  {
    path: "/consultant/candidate-requirement",
    component: CandidateRequirement,
    moduleCodes: [CONSULTANCY.CANDIDATE_REQUIREMENT],
  },
];
